export default "__VITE_ASSET__g5aCe_fT__"